import { useContext } from "react"
import Loading from "./views/public/loading"
import LogIn from "./views/public/logIn"
import Main from "./views/private/main"
import NoTeam from "./views/private/noTeam"
import NotEnoughUsers from "./views/private/notEnoughUsers"
import { AuthContext } from "./controllers/auth"
import { MainController } from "./controllers/main"
import { ActivitiesController } from "./controllers/activities"
import { HelperController } from "./controllers/helper"
import { FootprintController } from "./controllers/footprint"
import { EducationController } from "./controllers/education"
import { Compose } from "./services/utils/utils"
import { OverviewController } from "./controllers/overview"
import { ChallengesController } from "./controllers/challenges"
import { UserController } from "./controllers/user"
import Error from "./views/public/error"
import { StoriesController } from "./controllers/stories"
import { MobilityController } from "./controllers/mobility"

const App = () => {
  const { loading, isAuth, viewErrorPage, viewNoTeamPage, viewNotEnoughUsersPage } =
    useContext(AuthContext)

  // all controllers
  const controllers = [
    MainController,
    OverviewController,
    EducationController,
    FootprintController,
    ActivitiesController,
    ChallengesController,
    UserController,
    StoriesController,
    MobilityController,
    HelperController,
  ]

  if (viewErrorPage) {
    return <Error />
  }

  if (loading) {
    return <Loading />
  }

  if (!isAuth) {
    return <LogIn />
  }

  if (viewNoTeamPage) {
    return <NoTeam />
  }

  if (viewNotEnoughUsersPage) {
    return <NotEnoughUsers />
  }

  return (
    <Compose components={controllers}>
      <Main />
    </Compose>
  )
}

export default App
